import React, { useId, useState } from "react";

function PasswordInput({
  value,
  onChange,
  onBlur,
  placeholder,
  required,
  minLength,
  autoComplete = "current-password",
  name
}) {
  const [visible, setVisible] = useState(false);
  const baseId = useId();
  const inputId = `${baseId}-pwd`;

  return (
    <div className="auth-password-field">
      <input
        id={inputId}
        type={visible ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        minLength={minLength}
        autoComplete={autoComplete}
        name={name}
      />
      <button
        type="button"
        className="auth-password-toggle"
        onClick={() => setVisible((current) => !current)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
      >
        {visible ? "Hide" : "Show"}
      </button>
    </div>
  );
}

export default PasswordInput;
